import * as React from "react";
function SvgX(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="sociavore-icon" width="1em" height="1em" {...props}><path d="M18 6L6 18M6 6l12 12" /></svg>;
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InNvY2lhdm9yZS1pY29uIj4KICA8bGluZSB4MT0iMTgiIHkxPSI2IiB4Mj0iNiIgeTI9IjE4Ij48L2xpbmU+CiAgPGxpbmUgeDE9IjYiIHkxPSI2IiB4Mj0iMTgiIHkyPSIxOCI+PC9saW5lPgo8L3N2Zz4K";
export { SvgX as ReactComponent };